module.exports = __webpack_public_path__ + "img/HPFM_machete_mobile.a6dccbcb.png";